import urls from '@src/http/urls'
import { AuthDef } from './index.module'
export default class {
    [AuthDef.main.serviceName]({
        GET
    }, params) {
        const url = AuthDef.main.url;
        return GET(url, params)
    }
}